<app-layout-container [showSidebar]="true" [showHeader]="true">
    <router-outlet></router-outlet>
</app-layout-container>